module.exports = __webpack_public_path__ + "static/media/fan.3aca87c3.png";